
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1vtzr_o20mv_5",
  "view-button": "awsui_view-button_1vtzr_o20mv_9",
  "browse-button": "awsui_browse-button_1vtzr_o20mv_13",
  "layout": "awsui_layout_1vtzr_o20mv_17",
  "layout-uri": "awsui_layout-uri_1vtzr_o20mv_29",
  "layout-version": "awsui_layout-version_1vtzr_o20mv_33",
  "layout-divider": "awsui_layout-divider_1vtzr_o20mv_38"
};
  